import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {CampaignContactType} from "./campaign-contact-type";
import Datatable from "../../datatable/datatable";
import {CampaignContactTypeService} from "./campaign-contact-type.service";
import {changePageTitle, setAlert} from "../../redux/actions";
import {ColorButtonEnum} from "../../util/color-button-enum";
import {ColorIconEnum} from "../../util/color-icon-enum";
import {Delete as DeleteIcon} from "@mui/icons-material";

const CampaignContactTypeList = React.memo(() => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState<CampaignContactType[]>([]);
    const [page, setPage] = useState<number | undefined>(0);
    const [size, setSize] = useState<number | undefined>(parseInt(process.env.REACT_APP_PAGE_SIZE || "0"));
    const [sort, setSort] = useState<string | undefined>('id,asc');
    const [filter, setFilter] = useState<string | undefined>('');

    const findAll = useCallback(async (page?: number, size?: number, sort?: string, filter?: string) => {
        const result = await CampaignContactTypeService.findAll(page, size, sort, filter);
        setItems(result.content);
        setPage(page);
        setSize(page);
        setSort(sort);
        setFilter(filter);
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Tipos de contatos de campanhas"));
        findAll(page, size, sort, filter).then();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const insertItem = () => {
        navigate('/campaigncontacttype');
    }

    const editItem = (item: CampaignContactType) => {
        navigate('/campaigncontacttype/' + item.id);
    }

    const deleteItem = (item: CampaignContactType) => {
        if (item.id) {
            CampaignContactTypeService.delete(item.id).then(() => {
                findAll(page, size, sort, filter).then();
            }).catch((error) => {
                dispatch(setAlert({
                    show: true,
                    message: 'Erro ao excluir registro - ' + error.response.data.message,
                    severity: 'error'
                }));
            })
        }
    }

    const headerOperations = [{color: () => ColorButtonEnum.PRIMARY, onClick: insertItem, label: () => 'Inserir'}];

    const rowOperations = [{
        color: () => ColorIconEnum.PRIMARY,
        onClick: deleteItem,
        label: () => 'Excluir',
        icon: () => <DeleteIcon/>
    }];

    return (
        <React.Fragment>
            <Datatable
                dataColumnNames={['ID', 'Descrição']}
                dataColumns={['id', 'description']}
                dataTypes={['number', 'text']}
                findAll={findAll}
                page={page}
                size={size}
                sort={sort}
                filter={filter}
                editData={editItem}
                data={items}
                totalData={items.length}
                headerOperations={headerOperations}
                rowOperations={rowOperations}
            />
        </React.Fragment>
    )

});

export default CampaignContactTypeList;